import React, { useMemo } from 'react';
import { useGetAllActivityItemsQuery, useGetAllActivityTypesQuery } from './activitySlice';
import { Grid } from '@material-ui/core';
import CustomInput from 'components/CustomInput';
import { arrayToObject } from 'utils/object-util';

const ActivityTypesField = ({ required = true, onChange, value, label = "Activity Type", readonly = false }) => {

    const { data: activityItems, error: activityItemsError, isFetching: isLoadingActivityItems } = useGetAllActivityItemsQuery();
    const { data: activityTypes, error: activityTypesError, isFetching: isLoadingActivityTypes } = useGetAllActivityTypesQuery();

    const combinedData = useMemo(() => {
        if (!activityItems || !activityTypes) return [];
        const sortedActivityTypes = [...activityTypes]?.sort((a, b) => a.name.localeCompare(b.name));
        const sortedActivityItems = [...activityItems]?.sort((a, b) => a.name.localeCompare(b.name));

        return sortedActivityTypes.map(type => ({
            label: type.name,
            options: sortedActivityItems
                .filter(item => item.activityTypeId === type.id)
                .map(item => ({ label: item.name, value: item.id }))
        }));
    }, [activityTypes, activityItems]);

    let activityItemsLookup = arrayToObject(activityItems);

    return (
        <>
            {readonly ? <label>{activityItemsLookup?.[value]?.name}</label> :
                <Grid>
                    <CustomInput
                        id="activityTypeId"
                        label={label}
                        elementType="dropdown"
                        combinedData={combinedData}
                        value={value}
                        required={required}
                        showEmpty={true}
                        onChange={onChange}
                    />
                </Grid>}
        </>
    );
};

export default ActivityTypesField;